import React from 'react';
import { motion } from 'framer-motion';
import { Landmark, Car, Zap } from 'lucide-react';
const INVESTOR_URL = 'https://project-flash-and-go-investor-landing-page-109.magicpatterns.app';
const stats = [{
  value: 'Desde U$S 10.000',
  label: 'Inversión mínima'
}, {
  value: '2% mensual',
  label: 'Rentabilidad'
}, {
  value: '24% anual',
  label: 'En dólares'
}, {
  value: 'Pagos mensuales',
  label: 'Sin demoras'
}];
const comparison = [{
  icon: Landmark,
  label: 'Plazo fijo en dólares',
  value: '0.5% mensual',
  badge: 'Mercado tradicional',
  highlight: false
}, {
  icon: Car,
  label: 'Competencia del sector',
  value: '~0.9% mensual',
  badge: 'Promedio del mercado',
  highlight: false
}, {
  icon: Zap,
  label: 'Flash & Go Inversiones',
  value: '2% mensual',
  subtext: '24% anual en dólares',
  badge: 'MÁS DEL DOBLE',
  highlight: true
}];
export function InversionesBanner() {
  return <section className="bg-[#111] border-y border-brand-gold/30" data-id="element-395" data-mp="ektuslc9x09h">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-24" data-id="element-396" data-mp="en6dx1trpgo4">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-397" data-mp="9lh2hl2mv0zi">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-398" data-mp="ok2n79rhq6tq">
            <div className="inline-block px-4 py-1.5 bg-brand-gold/10 border border-brand-gold text-brand-gold text-sm font-bold tracking-wider mb-6 rounded-full" data-id="element-399" data-mp="3n16m7wxu7zv2">
              2% MENSUAL — 24% ANUAL EN DÓLARES
            </div>
            <h2 className="font-heading text-5xl md:text-6xl mb-6" data-id="element-400" data-mp="tosfbhittvg">
              <span className="text-brand-white block" data-id="element-401" data-mp="399s2fnw3vumy">
                ¿Querés que tu dinero
              </span>
              <span className="text-brand-gold block" data-id="element-402" data-mp="34axbtzrwd1sa">trabaje por vos?</span>
            </h2>
            <p className="text-xl text-brand-white/70 mb-8 max-w-lg" data-id="element-403" data-mp="3tz2ngm6wzy0s">
              Flash & Go ya opera, ya genera y ya paga. Sumate a nuestra red de
              inversores y generá ingresos en dólares desde el primer mes. Sin
              complicaciones, sin sorpresas.
            </p>
            <div className="flex flex-wrap gap-3 mb-8" data-id="element-404" data-mp="bktqcyb6mvoh">
              {['⚡ Modelo probado', '✅ Ya estamos pagando', '📈 Múltiples fuentes de ingreso'].map(pill => <span key={pill} className="bg-brand-black border border-brand-gold/40 text-brand-white/90 text-sm font-medium px-3 py-1.5 rounded-full" data-id="element-405" data-mp="3f2le20iactgv">
                  {pill}
                </span>)}
            </div>
            <a href={INVESTOR_URL} className="inline-flex items-center justify-center px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-406" data-mp="zaxm6ji4pr4x">
              QUIERO INVERTIR →
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-black border border-brand-gold/20 p-6 sm:p-8 rounded-2xl" data-id="element-407" data-mp="2jrx0sa2cu5eg">
            <div className="grid grid-cols-2 gap-x-6 gap-y-8" data-id="element-408" data-mp="25yp6gamw2vt2">
              {stats.map((stat, i) => <div key={i} data-id="element-409" data-mp="214beyjbcl8to" data-mpi={i}>
                  <div className="font-heading text-3xl sm:text-4xl text-brand-gold mb-2 leading-none" data-id="element-410" data-mp="1w22mdo2e08s3">
                    {stat.value}
                  </div>
                  <div className="text-brand-white/60 text-sm" data-id="element-411" data-mp="1r65gkbor2ktk">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* Comparison */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20" data-id="element-412" data-mp="3ti8cl45c269n">
          <h3 className="font-heading text-4xl md:text-5xl text-brand-gold text-center mb-10" data-id="element-413" data-mp="3ojf1fidiqrcn">
            ¿Por qué Flash & Go?
          </h3>

          <div className="space-y-4 max-w-3xl mx-auto" data-id="element-414" data-mp="3ar8ijoize69i">
            {comparison.map((row, i) => {
            const Icon = row.icon;
            return <div key={i} className={`flex items-center gap-4 sm:gap-6 p-5 sm:p-6 rounded-xl border ${row.highlight ? 'bg-brand-gold/10 border-brand-gold' : 'bg-[#1A1A1A] border-white/5'}`} data-id="element-415" data-mp="30u2smjm3slav" data-mpi={i}>
                  <div className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${row.highlight ? 'bg-brand-gold/20' : 'bg-white/5'}`} data-id="element-416" data-mp="2rto3f960qm23">
                    <Icon className={`w-6 h-6 ${row.highlight ? 'text-brand-gold' : 'text-brand-white/40'}`} data-id="element-417" data-mp="2d6z69dz8okyv" />
                  </div>

                  <div className="flex-grow min-w-0" data-id="element-418" data-mp="2m86sgxohdvcl">
                    <p className={`font-bold text-sm sm:text-base ${row.highlight ? 'text-brand-white' : 'text-brand-white/70'}`} data-id="element-419" data-mp="2m4rdduut4mb6">
                      {row.label}
                    </p>
                    <span className={`inline-block mt-1 text-[11px] font-bold px-2 py-0.5 rounded ${row.highlight ? 'bg-brand-gold text-brand-black' : 'bg-white/10 text-brand-white/50'}`} data-id="element-420" data-mp="2r6qd8urc913d">
                      {row.badge}
                    </span>
                  </div>

                  <div className="shrink-0 text-right" data-id="element-421" data-mp="3ewui15g9j6vy">
                    <div className={`font-heading text-2xl sm:text-3xl leading-none ${row.highlight ? 'text-brand-gold' : 'text-brand-white/50'}`} data-id="element-422" data-mp="39wq2pir3ci7b">
                      {row.value}
                    </div>
                    {row.subtext && <div className="text-brand-gold text-xs sm:text-sm mt-1" data-id="element-423" data-mp="2bij19p6hofoj">
                        {row.subtext}
                      </div>}
                  </div>
                </div>;
          })}
          </div>

          <p className="text-brand-gold text-center font-medium mt-8 mb-8 text-lg" data-id="element-424" data-mp="2q902b7f7p3kw">
            Más del doble que cualquier alternativa del mercado.
          </p>

          <div className="text-center" data-id="element-425" data-mp="2zapx8n8ayknf">
            <a href={INVESTOR_URL} className="inline-flex items-center justify-center px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-426" data-mp="2zazlo6dp8jr0">
              QUIERO INVERTIR →
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}